var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { api, apiPublic, apiRoot } from 'config';
import { getToken } from '..';
export { default as login } from './pages/login';
export { services, intervals, days, workWeeks, officeParams, officeParamsBinding, } from './pages/services';
export { archive } from './pages/statistics';
export { workplaces, sounds } from './pages/workplaces';
// const camelCaseToUnderscore = (key: string) =>
//   key.replace(/([A-Z])/g, '_$1').toLowerCase();
var encode = function (s) { return encodeURIComponent(s).replace(/%20/g, '+'); };
function buildArgs(args) {
    if (args) {
        return Object.keys(args || {}).reduce(function (url, k) { return "".concat(url).concat(k, "=").concat(encode(args[k]), "&"); }, '');
    }
    return '';
}
export var baseGetApi = function (apiEntry, method, add) { return __awaiter(void 0, void 0, void 0, function () {
    var token, queryString, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                token = new URLSearchParams(window.location.search).get('token');
                queryString = method
                    ? "?action=".concat(method, "&token=").concat(getToken() || token).concat(buildArgs(add === null || add === void 0 ? void 0 : add.args))
                    : '';
                return [4 /*yield*/, axios({
                        method: 'POST',
                        url: "".concat(api, "/").concat(apiEntry, "/").concat((add === null || add === void 0 ? void 0 : add.id) || '').concat(queryString),
                        data: add === null || add === void 0 ? void 0 : add.payload,
                    })];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data];
        }
    });
}); };
export var publicApi = function (apiEntry, args) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios({
                    method: 'POST',
                    url: "".concat(apiPublic, "/").concat(apiEntry, "/?").concat(buildArgs(args)),
                })];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data];
        }
    });
}); };
export var rootApi = function (apiEntry) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios({
                    url: "".concat(apiRoot).concat(apiEntry),
                })];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data];
        }
    });
}); };
export var rootApiPost = function (apiEntry, data, headers) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios.post("".concat(apiRoot).concat(apiEntry), data, headers)];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data];
        }
    });
}); };
export var rootApiDelete = function (apiEntry, data) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios.delete("".concat(apiRoot).concat(apiEntry), data)];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data];
        }
    });
}); };
export var rootApiPatch = function (apiEntry, data) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios.patch("".concat(apiRoot).concat(apiEntry), data)];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data];
        }
    });
}); };
export var rootApiAdd = function (apiEntry) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios({
                    method: 'POST',
                    url: "".concat(apiRoot).concat(apiEntry),
                    data: {
                        token: getToken(),
                    },
                })];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data];
        }
    });
}); };
